import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import MuiTable from '@mui/material/Table';
import { useMemo, useRef } from 'react';
import { Button } from '@mui/material';
import { mdiRefresh } from '@mdi/js';
import { Icon } from '@mdi/react';
import { defineStyles } from '../theme';
import LoadingBackdrop from '../components/LoadingBackdrop';
import { ColumnsMaxWidthsContext } from './ColumnWidthsContext';
import { UserColumnWidthsProvider } from './UserColumnWidthsContext';
import { useSTContext, useSTRowFilterCondition, useSTRows } from './SmartTableContext';
import { TableBody } from './TableBody/TableBody';
import { TableHeader } from './TableHeader/TableHeader';
import ClearSortButton from './builtInButtons/ClearSortButton/ClearSortButton';
import ConfigureColumnsButton from './builtInButtons/ConfigureColumnsButton/ConfigureColumnsButton';
import DeleteDuplicatesButton from './builtInButtons/DeleteDuplicatesButton/DeleteDuplicatesButton';
import { hasDuplicityFilter } from './helpers';
import { BatchEditButton } from './builtInButtons/BatchEditButton';
import { DeleteRowsButton } from './builtInButtons/DeleteRowsButton';
import { NewRowButton } from './builtInButtons/NewRowButton';
import MaxRecordsButton from './builtInButtons/MaxRecordsButton/MaxRecordsButton';
import { EmptyRows } from './EmptyRows/EmptyRows';
import { SelectionCountDisplay } from './SelectionCountDisplay';
const styles = defineStyles({
    root: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    table: {
        mt: 1,
        height: '100%',
        overflow: 'auto',
        position: 'relative',
    },
    actionsBar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    rightActions: {
        display: 'flex',
        columnGap: 1,
    },
    leftActions: {
        display: 'flex',
        columnGap: 1,
        alignItems: 'center',
    },
    actionContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    refreshButton: {
        minWidth: 35,
    },
});
export function TableContainer({ shownBuiltInActions, allowNewColumns, leftActions, rightActions, bulkActions, hideMaxRecordsForm, }) {
    const tableContainerRef = useRef(null);
    const [filters] = useSTRowFilterCondition();
    const { resetRows } = useSTContext();
    const { rowsLoading } = useSTRows();
    const shouldShowDeleteDuplicatesButton = useMemo(() => hasDuplicityFilter(filters), [filters]);
    return (_jsx(ColumnsMaxWidthsContext, { children: _jsx(UserColumnWidthsProvider, { children: _jsxs(Box, { sx: styles.root, children: [_jsxs(Box, { sx: styles.actionsBar, children: [_jsxs(Box, { sx: styles.leftActions, children: [leftActions, _jsx(SelectionCountDisplay, {}), shownBuiltInActions?.includes('batchEdit') && _jsx(BatchEditButton, { allowNewColumns: allowNewColumns }), shownBuiltInActions?.includes('deleteRows') && _jsx(DeleteRowsButton, {}), shouldShowDeleteDuplicatesButton && _jsx(DeleteDuplicatesButton, {}), bulkActions, resetRows && (_jsx(Button, { onClick: resetRows, sx: styles.refreshButton, children: _jsx(Icon, { path: mdiRefresh, size: 0.8 }) })), shownBuiltInActions?.includes('addRow') && _jsx(NewRowButton, { allowNewColumns: allowNewColumns })] }), _jsxs(Box, { sx: styles.rightActions, children: [!hideMaxRecordsForm && shownBuiltInActions?.includes('maxRecords') && _jsx(MaxRecordsButton, {}), shownBuiltInActions?.includes('configureColumns') && _jsx(ConfigureColumnsButton, {}), shownBuiltInActions?.includes('clearSort') && _jsx(ClearSortButton, {}), rightActions] })] }), _jsxs(Box, { sx: styles.table, ref: tableContainerRef, children: [_jsxs(MuiTable, { stickyHeader: true, children: [_jsx(TableHeader, {}), _jsx(TableBody, { tableContainerEl: tableContainerRef.current })] }), _jsx(EmptyRows, {}), _jsx(LoadingBackdrop, { isLoading: rowsLoading, contained: true })] })] }) }) }));
}
//# sourceMappingURL=TableContainer.js.map